// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
import './common/AzureUploadLargeFileChunks.js'; import './common/GenerateMockRelations.js'; import './common/GetAzureReadImageResult.js'; import './common/models/Email.js'; import './common/ParseAzureOCRResponse.js';
;
import './web/Dropdown.jsx';

